import { render, staticRenderFns } from "./OverseaStudentDetailPage.vue?vue&type=template&id=3ec843a6&scoped=true"
import script from "./OverseaStudentDetailPage.vue?vue&type=script&lang=js"
export * from "./OverseaStudentDetailPage.vue?vue&type=script&lang=js"
import style0 from "./OverseaStudentDetailPage.vue?vue&type=style&index=0&id=3ec843a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec843a6",
  null
  
)

export default component.exports